import {
  type ImgHTMLAttributes,
  useLayoutEffect,
  useRef,
  useState,
} from "react";
import { EmbedContainer } from "./EmbedContainer.tsx";

export const BaseImage = ({
  imageClassName,
  onLoad,
  src,
  loading = "eager",
  className,
  ...rest
}: Omit<ImgHTMLAttributes<HTMLImageElement>, "src"> & {
  src?: string | null;
  imageClassName?: string;
}) => {
  const [isLoaded, setIsLoaded] = useState(false);

  const ref = useRef<HTMLImageElement>(null);
  useLayoutEffect(() => {
    if (ref.current?.complete) setIsLoaded(true);
  }, [setIsLoaded]);

  // XXX: for the lazy load to work, the image cannot have a width and height that are 0. Also, it cannot be hidden.
  // We add a wrapper div to be able to add the loader in absolute above the lazy loading image.
  return (
    <EmbedContainer className={className} isLoaded={isLoaded}>
      <img
        ref={ref}
        src={src ?? undefined}
        className={imageClassName}
        alt=""
        loading={loading}
        onLoad={(event) => {
          setIsLoaded(true);
          onLoad?.(event);
        }}
        {...rest}
      />
    </EmbedContainer>
  );
};
